import { initializeApp } from "firebase/app";
import {getDatabase} from 'firebase/database';

import { getAuth } from "firebase/auth";



const firebaseConfig = {

    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  
    authDomain: "smartwaste-ddeeb.firebaseapp.com",
  
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  
    projectId: "smartwaste-ddeeb",
  
    storageBucket: "smartwaste-ddeeb.appspot.com",
  
    messagingSenderId: "655854344542",
  
    appId: "1:655854344542:web:7f9d200df5f91d408757cf",
  
    measurementId: "G-PMBKHGE9DZ"
  
};


const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
export default auth

export const db = getDatabase(app);
